/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Kanban = [
  ["path", { d: "M5 3v14" }],
  ["path", { d: "M12 3v8" }],
  ["path", { d: "M19 3v18" }]
];

export { Kanban as default };
//# sourceMappingURL=kanban.js.map
